export default __webpack_public_path__ + "static/media/City_of_Code_GitHub.d517598a.webp";